import { BaseError } from './base';

export class SimulationFailedError extends BaseError {
  constructor(params: { cause?: Error; message: string }) {
    super({
      cause: params.cause || null,
      code: 'simulation_failed_error',
      docsUrl: null,
      name: 'SimulationFailedError',
      shortMessage: params.message,
    });
  }
}
